import { MENU_CISELNIKY, MENU_CISELNIK_OV, MENU_OJETEVOZY, RouteType, MENU_NV } from '@/main/menu/constants';
import { MenuItem, menuBase } from '@/main/menu/menu';
import axios, { AxiosResponse } from 'axios';
import _ from 'lodash';
import { ActionTree } from 'vuex';

import { TENANT_NAME } from '../authorization/constants';
import { External, ExternalMenu, ExternalLocalizations } from '../@types/external.d';
import { RootStore } from '../@types/store';
import { ERROR } from '../actionTypes';
import { types } from './types';
import { VUE_APP_TENANT_HOST } from '../constants';

function setMenuOv(ojeteVozyMenu: ExternalMenu, resource: ExternalLocalizations) {
	if (ojeteVozyMenu.list && ojeteVozyMenu.list.length > 0) {
		const menuNvIndex = menuBase.items.findIndex((item) => item.name === MENU_NV) + 1;
		const sufixItems = menuBase.items.splice(menuNvIndex);
		menuBase.items = menuBase.items.splice(0, menuNvIndex);
		menuBase.addItem({
			...ojeteVozyMenu,
			name: resource.menu!.main[ojeteVozyMenu.i18nKey],
			list: recursiveMenuMapper(ojeteVozyMenu.list, resource),
		}, 'icon-car-old');
		menuBase.items = menuBase.items.concat(sufixItems);
	}
}

function recursiveMenuMapper(list: ExternalMenu[], resource: ExternalLocalizations): ExternalMenu[] {
	const menuItems = list.map((inner) => {
		const clonedInner = _.cloneDeep(inner);

		if (clonedInner.list && clonedInner.list.length > 0) {
			clonedInner.list = recursiveMenuMapper(clonedInner.list, resource);
		}

		return {
			...clonedInner,
			name: resource.menu.main[clonedInner.i18nKey],
		};
	});

	return menuItems;
}

function setMenuCiselnikyOv(ojeteVozyCiselniky: ExternalMenu, resource: ExternalLocalizations) {
	const menuCiselnikOv = menuBase.items.find((item) => item.name === MENU_CISELNIKY)?.items.find((item) => item.name === MENU_CISELNIK_OV);

	const mapedExternalCiselnikOvMenu = ojeteVozyCiselniky?.list?.map(
		(item) => new MenuItem(
			resource.menu.codeList[item.i18nKey],
			item.route || null,
			RouteType.external,
			null,
			false,
			item.newTab,
		),
	) || [];

	menuCiselnikOv!.items = menuCiselnikOv?.items.concat(mapedExternalCiselnikOvMenu) || [];
}

export const actions: ActionTree<External, RootStore> = {
	[types.actions.INIT_EXTERNAL_MODULES]: async ({ dispatch, commit, rootState }) => {
		try {
			const tenantName = window.localStorage.getItem(TENANT_NAME);
			let resp: AxiosResponse;
			if (window.location.hostname === 'local.dms') {
				resp = await axios.get('/mpov/config.json');
			} else {
				if (!tenantName) {
					return;
				}
				return;
				// resp = await axios.get(`/dmsapi/Extapi/OjeteVozy/mpov/Config?tenant=${tenantName}`);
			}
			// As this code is not required for DMS so commenting this is releted to Sales Application
			// const src = resp.data.mpov;
			// const api = resp.data.api ? resp.data.api : resp.data.mpov;
			// const externalRoute = window.location.pathname;
			// const { tenant } = resp.data;

			// const { data: ojeteVozyMenu }: { data: ExternalMenu } = await axios.get(`${api}/api/v1/Menu/Main`);
			// const { data: ojeteVozyCiselniky }: { data: ExternalMenu } = await axios.get(`${api}/api/v1/Menu/CodeList`);
			// const { data: resource } = await axios.get(`${api}/api/v1/Resource/?languageId=${rootState.loggedUser.UzivatelData.LanguageId}`);

			// setMenuOv(ojeteVozyMenu, resource);
			// setMenuCiselnikyOv(ojeteVozyCiselniky, resource);

			// const tenantHost = !_.isUndefined(process.env.VUE_APP_TENANT_HOST) && process.env.VUE_APP_TENANT_HOST.length > 0
			// 	? process.env.VUE_APP_TENANT_HOST
			// 	: `${window.location.protocol}//${window.location.host}`;

			// TODO: priamo nastavovat MenuBase bez nutnosti ukladania menu do vuexu
			// commit(types.mutations.INITIALISE_STORE, { resource, tenantHost, tenant, src, api, externalRoute });
		} catch (err) {
			dispatch(ERROR, { err }, { root: true });
		}
	},
	[types.actions.GO_TO_EXTERNAL_ROUTE]: ({ commit }, { route, isPreviousRouteInternal }) => {
		const external = document.getElementById('external-module') as HTMLIFrameElement;
		const targetWindow = external.contentWindow;
		const isMpovLoggedIn = Boolean(window.localStorage.getItem('INITIALIZATION_KEY'));

		if (targetWindow && !isPreviousRouteInternal && isMpovLoggedIn) {
			const listener = (event: any) => {
				if (event.data === 'allow' || event.data === 'deny') {
					if (!route.includes(MENU_OJETEVOZY)) {
						window.removeEventListener('message', listener);
					}
				}
				if (event.data === 'allow') {
					commit(types.mutations.REPLACE_EXTERNAL_ROUTE, route);
				}
			};

			window.addEventListener('message', listener, false);
			const targetOrigin = !_.isUndefined(VUE_APP_TENANT_HOST[0]?.toString()) && VUE_APP_TENANT_HOST[0]?.toString().length > 0
		? VUE_APP_TENANT_HOST[0]?.toString()
		: `${window.location.protocol}//${window.location.host}`;
	
			targetWindow.postMessage('routeChange', targetOrigin);
		} else {
			commit(types.mutations.REPLACE_EXTERNAL_ROUTE, route);
		}
	},
};
